import { css, cx } from '@emotion/css';

import {
  AlignContent,
  AlignItems,
  BorderRadius,
  Color,
  Display,
  FlexDirection,
  Font,
  FontWeight,
  JustifyContent,
  ScreenBreakpoint,
  Spacing,
} from '../../../../../../styles';

export const container = css`
  ${Spacing.mx32}
  ${Spacing.my16}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.mx16}
    ${Spacing.my8}
  }
`;

export const section = css`
  ${Display.flex}
  ${JustifyContent.spaceBetween}
  ${Spacing.my16}
  ${AlignItems.center}

  @media (max-width: ${ScreenBreakpoint.mobile.min}) {
    ${FlexDirection.column}
    ${AlignItems.flexStart}
  }
`;

export const card = css`
  ${Spacing.p16}
  ${Display.inlineBlck}
  width:100%;
  background-color: ${Color.Gray1};

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.p8}
  }
`;

export const subTitle = css`
  ${Font.md}
  ${FontWeight.bold}
  color: ${Color.Gray8};
  /* No margin, so the next line sits against the title. */
  && {
    ${Spacing.m0}
  }
`;

export const paragraph = css`
  ${Font.md}
  ${FontWeight.normal}
  color: ${Color.Gray7};
  /* No top margin, so a bold title stays attached to the text under it. */
  && {
    ${Spacing.mt0}
    ${Spacing.mb16}
  }
`;

export const acceptableAndUnaccaptableRow = css`
  width: 100%;
  ${Spacing.mt20}
  ${AlignItems.flexStart}
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${FlexDirection.column}
    ${AlignContent.flexStart}
  }
`;

export const acceptableAndUnaccaptableSubtitle = css`
  ${Font.sm}
  ${FontWeight.bold}
  color: ${Color.Gray8};
`;

export const acceptableAndUnaccaptableList = css`
  ${Spacing.pl20}
  && {
    ${Spacing.mt0}
  }
`;

export const checkInfoCol = css`
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.mt8}
  }
`;

export const baseIcon = css`
  width: 2rem;
  height: 2rem;
  ${Font.h5}
  ${BorderRadius.md}
  ${Display.flex}
  ${AlignItems.center}
  ${JustifyContent.center}
`;

export const checkIcon = cx(
  baseIcon,
  css`
    color: ${Color.Green6};
    background-color: ${Color.Green2};
  `,
);

export const closeIcon = cx(
  baseIcon,
  css`
    color: ${Color.Red6};
    background-color: ${Color.Red2};
  `,
);
